import { fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import { Field } from "styles/formStyles";
import Button from "components/Button/Button";

export const Wrapper = styled.div`
  animation: 0.6s ${keyframes`${fadeIn}`};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  ${(props) => props.theme.xs`
    justify-content: space-between;
  `}
`;

export const SearchGroup = styled.div`
  flex: 1;
  min-width: 160px;
  position: relative;

  input {
    width: 100%;
    padding-right: 36px;
  }
`;

export const SearchInputStyled = styled.input`
  ${Field};
`;

export const SearchButton = styled(Button)`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 10px 0 5px;
  display: flex;
  align-items: center;

  .icon {
    height: 15px;
    width: 15px;
    transition: background-color 0.3s;
  }

  &:hover .icon {
    background-color: ${(props) => props.theme.primary};
  }
`;
